module.exports = __webpack_public_path__ + "static/DailyBriefimg-675e98c07e695b9e4abd60837e8ea593.png";